<template>
  <div class="ratingStar">
    <div class="active-stars">
      <icon v-for="index in MAX_NUMBER_STAR" :key="index" :class="props.starSize" fas="fa-star" class="active" />
    </div>
    <div class="overlay-stars">
      <icon v-for="index in MAX_NUMBER_STAR" :key="index" :class="props.starSize" fas="fa-star" />
    </div>
  </div>
</template>

<script setup lang="ts">
const MAX_NUMBER_STAR = 5

interface Props {
  numberStar?: string | number
  starSize?: string
}

const props = withDefaults(defineProps<Props>(), {
  numberStar: '0',
  starSize: 'medium'
})
const overlayPercentage = computed(() => `${Math.round((Number(props.numberStar) / MAX_NUMBER_STAR) * 100)}%`)
</script>

<style lang="scss" scoped>
.ratingStar {
  position: relative;
  margin-right: 5px;
  display: block;
  min-width: 100px;
  .medium {
    font-size: 1.9rem;
    @media screen and (max-width: 320px) {
      font-size: 1.6rem;
    }
  }
  .small {
    font-size: 1.6rem;
    @media screen and (max-width: 320px) {
      font-size: 1.4rem;
    }
  }
  .active-star,
  .overlay-stars {
    position: absolute;
    top: 0;
  }
  .active {
    color: $bird_flower;
  }
  .overlay-stars {
    color: $gray-c6;
    clip-path: inset(0 0 0 v-bind(overlayPercentage));
  }
  :deep(svg) {
    margin-right: 0.2rem;
  }
}
</style>
